import { Box } from '@mui/material';
import { forwardRef, Ref } from 'react';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers';
import moment from 'moment';
type CAppFormKeyboardDatePickerProps<TInputDate, TDate> = DatePickerProps<TInputDate, TDate> & {
	isViewOnly?: boolean;
	valueViewOnly?: string;
};
const CAppFormKeyboardDatePicker = <TInputDate, TDate>(
	props: CAppFormKeyboardDatePickerProps<TInputDate, TDate> & {
		onChange: (val: Date) => void;
	},
	ref: Ref<HTMLDivElement>,
) => {
	const { isViewOnly, valueViewOnly, onChange, ...otherProps } = props;

	return (
		<>
			{isViewOnly ? (
				<>
					<Box sx={{ fontSize: '0.9rem' }}>{otherProps.label} :</Box>
					<Box sx={{ fontWeight: 600 }}>
						{valueViewOnly ?? (otherProps.value ? moment(otherProps.value).format('DD/MM/YYYY') : 'n.c.')}
					</Box>
				</>
			) : (
				<DatePicker
					{...otherProps}
					ref={ref}
					onChange={(val) =>
						// Force UTC date only when we don't keep timestamp in database
						onChange(
							val
								? (moment(moment(val).format('YYYY-MM-DD')).utc(true).toDate() as Date)
								: (null as unknown as Date),
						)
					}
				/>
			)}
		</>
	);
};

export default forwardRef(CAppFormKeyboardDatePicker);
